import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import i18n from '../i18n';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);   // null = ikke indlæst endnu
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    if (!api.isLoggedIn()) { setLoading(false); return; }
    try {
      const me = await api.me();
      setUser(me);
      if (me.language) i18n.changeLanguage(me.language);
    } catch (err) {
      if (err.message === 'SESSION_EXPIRED') api.clearTokens();
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (email, password) => {
    const data = await api.login(email, password);
    api.saveTokens(data);
    setUser(data.user);
    if (data.user.language) i18n.changeLanguage(data.user.language);
    return data;
  };

  const register = async ({ email, password, display_name, language }) => {
    const data = await api.register({ email, password, display_name, language });
    api.saveTokens(data);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    await api.logout();
    setUser(null);
  };

  const updateUser = (updates) => setUser(u => ({ ...u, ...updates }));

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser, reload: loadUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth skal bruges inden i AuthProvider');
  return ctx;
};
